import React from 'react'

export function UploadIcon({ width = '28', height = '28', ...props }) {
  return (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_1308_6747)">
        <g filter="url(#filter1_d_1308_6747)">
          <rect x="3.10059" y="1" width="20" height="20" rx="2.22973" fill="url(#paint0_linear_1308_6747)" />
        </g>
        <g clipPath="url(#clip0_1308_6747)">
          <path
            opacity="0.5"
            d="M15.1006 8.33203C15.5146 8.64252 15.8506 9.04513 16.082 9.50799C16.3134 9.97084 16.4339 10.4812 16.4339 10.9987C16.4339 11.5162 16.3134 12.0266 16.082 12.4894C15.8506 12.9523 15.5146 13.3549 15.1006 13.6654"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5"
            d="M16.9004 6.33203C17.5964 6.89446 18.1577 7.60545 18.5434 8.41291C18.929 9.22038 19.1292 10.1039 19.1292 10.9987C19.1292 11.8935 18.929 12.777 18.5434 13.5845C18.1577 14.3919 17.5964 15.1029 16.9004 15.6654"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.10059 13.0001H7.76725C7.59044 13.0001 7.42087 12.9299 7.29585 12.8049C7.17082 12.6799 7.10059 12.5103 7.10059 12.3335V9.66681C7.10059 9.49 7.17082 9.32043 7.29585 9.19541C7.42087 9.07038 7.59044 9.00014 7.76725 9.00014H9.10059L11.4339 6.00014C11.4922 5.88696 11.589 5.79836 11.7069 5.75034C11.8248 5.70232 11.956 5.69805 12.0768 5.73831C12.1975 5.77856 12.2999 5.86069 12.3654 5.96984C12.4309 6.07899 12.4552 6.20797 12.4339 6.33348V15.6668C12.4552 15.7923 12.4309 15.9213 12.3654 16.0305C12.2999 16.1396 12.1975 16.2217 12.0768 16.262C11.956 16.3022 11.8248 16.298 11.7069 16.2499C11.589 16.2019 11.4922 16.1133 11.4339 16.0001L9.10059 13.0001Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1308_6747"
          x="0.100586"
          y="0"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1308_6747" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1308_6747" result="shape" />
        </filter>
        <filter
          id="filter1_d_1308_6747"
          x="2.26444"
          y="0.721284"
          width="21.1149"
          height="21.1149"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.278716" dy="0.278716" />
          <feGaussianBlur stdDeviation="0.278716" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1308_6747" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1308_6747" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_1308_6747"
          x1="13.1006"
          y1="1"
          x2="13.1006"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D34279" />
          <stop offset="1" stopColor="#782645" />
        </linearGradient>
        <clipPath id="clip0_1308_6747">
          <rect width="16" height="16" fill="white" transform="translate(5.10059 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}
